import { action } from 'satcheljs';
import { OwaDate } from 'owa-datetime';
import { addDatapointConfig } from 'owa-analytics-actions';

/**
 * Sets the saveRequestTimeStamp value
 */
export let setCurrentSaveRequestTimeStamp = action(
    'setCurrentSaveRequestTimeStamp',
    (timeStamp: OwaDate) => ({ timeStamp })
);

/*
 * Action called to enable optional attendee well
 */
export let enableOptionalAttendeesWell = action('enableOptionalAttendeesWell');

/**
 * Action that updates isDarkMode flag
 */
export const setIsDarkMode = action('setIsDarkMode', (isDarkMode: boolean) =>
    addDatapointConfig(
        { name: 'CalDarkModeToggleClicked', customData: { owa_1: isDarkMode } },
        { isDarkMode }
    )
);

/*
 * Action called to set the online meeting selection state
 */
export let updateIsOnlineMeetingExplicitlySet = action('updateIsOnlineMeetingExplicitlySet');
